import React from 'react';

import DateTime from '../../DateTime';

export interface PublicationDateProps {
  publicationDate: Date;
  langcode: 'nl' | 'en';
}

const PublicationDate: React.FC<PublicationDateProps> = (props) => {
  const { publicationDate, langcode } = props;

  return (
    <DateTime
      date={publicationDate}
      translationKey="components.article_metadata.publication_date"
      langcode={langcode}
    />
  );
};

export default PublicationDate;
